import { useEffect, useState } from "react";
import { applyCoupon } from "../../services/CartService";
import Cart from "../cart/Cart";
// import AddressDetails from './AddressDetails'
import "./checkout.css";
import { useFormik } from "formik";
import { CoupenSchema, AddressSchema } from "./validation";
import { useDispatch, useSelector } from "react-redux";
import { fetchCartAmountDetials } from "../../redux/Slice/cartSlice";
import AppModal from "../../components/AppModal/AppModal";
import AddressForm from "../../components/AddressForm/AddressForm";
import "./tab.css";
import {
    createBillingAddressApi,
    createShippingAddressApi,
    getBillingAddress,
    getShippingddress,
    updateBillingAddressApi,
    updateShippingAddressApi,
} from "../../services/AddressService";
import AddressDetails from "./AddressDetails";
import { placeOrderCreate } from "../../services/OrderService";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";

const initialState = {
    coupon_code: "",
};
const billingInitialValues = {
    name: "",
    mobile_no: "",
    email: "",
    address_line_one: "",
    address_line_two: "",
    pincode: "",
    country_id: "",
    state_id: "",
    city_id: "",
    is_default: false,
    area: "",
};
const shippingInitialValues = {
    name: "",
    mobile_no: "",
    email: "",
    address_line_one: "",
    address_line_two: "",
    pincode: "",
    country_id: "",
    state_id: "",
    city_id: "",
    is_default: false,
    area: "",
};
function CheckOut() {
    const dispatch = useDispatch();
    const { isLoading, error, cartTotalAmount } = useSelector(
        (state) => state?.cartAmountDetails,
    );
    const [isPlaceOrder, setIsPlaceOrder] = useState(false);

    const token = localStorage.getItem("token");
    const [coupenLoading, setCoupenLoading] = useState(false);
    const [isAddressForm, setIsAddressForm] = useState(false);
    const [activeTab, setActiveTab] = useState("description");
    const [shippingAddress, setShippingAddress] = useState([]);
    const [billingAddress, setBillingAddress] = useState([]);
    const [isDisabled, setIsDisabled] = useState(false);
    const [mode, setMode] = useState("Add");
    const formik = useFormik({
        initialValues: initialState,
        validationSchema: CoupenSchema,
        onSubmit: handleFormSubmit,
    });

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };
    useEffect(() => {
        dispatch(fetchCartAmountDetials(token));
    }, []);
    useEffect(() => {
        getShippingAddressData(token);
        getBillingAddressData(token);
    }, []);

    const getShippingAddressData = async (token) => {
        try {
            const response = await getShippingddress(token);
            if (response?.status_code === 200) {
                setShippingAddress(response?.data || []);
            }
        } catch (error) {}
    };
    const getBillingAddressData = async (token) => {
        try {
            const response = await getBillingAddress(token);
            if (response?.status_code === 200) {
                setBillingAddress(response?.data || []);
            }
        } catch (error) {}
    };
    async function handleFormSubmit(values) {
        setCoupenLoading(true);

        try {
            const response = await applyCoupon(token, values);
            if (response?.status_code === 200) {
                dispatch(fetchCartAmountDetials(token));
                toast.success(response?.data?.message);

                setCoupenLoading(false);
                formik.resetForm();
            }
        } catch (error) {
            toast.error(error?.response?.data?.data?.error);
            setCoupenLoading(false);
        }
    }

    const billingAddressFormik = useFormik({
        initialValues: billingInitialValues,
        validationSchema: AddressSchema,
        onSubmit: handleBillingSubmit,
    });
    const shippingAddressFormik = useFormik({
        initialValues: shippingInitialValues,
        validationSchema: AddressSchema,
        onSubmit: handleShippingSubmit,
    });
    const [pincodeValidationError, setPincodeValidationError] = useState("");
    async function pincodeValidation(values) {
        let notError = false;
        try {
            const checkPinCode = Number(values.pincode);
            const validatePinCodeUrl = `https://api.postalpincode.in/pincode/${checkPinCode}`;
            const response = await fetch(validatePinCodeUrl);
            const data = await response.json();
            let resState = data[0]?.PostOffice[0]?.State?.replace(
                /\s+/g,
                "",
            )?.toLowerCase();
            let givenState = values?.state_name
                ?.replace(/\s+/g, "")
                ?.toLowerCase();
            let finalState = resState === givenState;

            if (data[0].Status === "Success" && finalState) {
                setPincodeValidationError("");
                return (notError = "Success");
            } else {
                setPincodeValidationError("Given Pin Code is InValid!!!");
                return;
            }
        } catch (error) {
            console.error("Error validating pincode:", error);
            setPincodeValidationError("Error validating pincode.");
            return;
        }
    }

    async function handleBillingSubmit(values) {
        // setIsDisabled(true);
        // pincodeValidation(values).then(async (x) => {
        //   if (
        //     Object.keys(billingAddressFormik.errors)?.length === 0 &&
        //     x === "Success"
        //   ) {
        //     setPincodeValidationError("");

        //   }
        // });

        let billingData = {
            id: values?.id,
            billing_address_id: values?.id,
            billing_name: values?.name,
            billing_email: values?.email,
            billing_phone_no: values?.mobile_no,
            billing_address_line_one: `${values?.address_line_one}`,
            billing_address_line_two: values?.address_line_two,
            billing_pincode: values?.pincode,
            billing_set_default: values?.is_default == true ? 1 : 0,
            billing_area: values?.area,
            billing_country: values?.country_id,
            billing_state: values?.state_id,
            billing_city: values?.city,
            billing_is_active: 1,
        };
        try {
            let billing = function modeAPIBillingCall() {
                if (billingData?.id) {
                    return updateBillingAddressApi(billingData, token);
                } else {
                    return createBillingAddressApi(billingData, token);
                }
            };
            let apicall = billing();
            const response = await apicall;
            //   const response = await createBillingAddressApi(billingData, token);
            if (response.status_code == 200) {
                toast.success(
                    `Billing address ${
                        billingData?.id ? "Updated" : "Added"
                    }  successfully!`,
                );
                getBillingAddressData(token);
                if (mode === "Edit") {
                    setIsAddressForm(false);
                }
                setActiveTab("specification");
                setIsDisabled(false);
            }
        } catch (error) {
            setIsDisabled(false);
        }
    }
    async function handleShippingSubmit(values) {
        let shippingvalues = {
            id: values?.id,
            shipping_address_id: values?.id,
            shipping_name: values?.name,
            shipping_email: values?.email,
            shipping_phone_no: values?.mobile_no,
            shipping_address_line_one: `${values?.address_line_one}`,
            shipping_address_line_two: values?.address_line_two,
            shipping_pincode: values?.pincode,
            shipping_set_default: values?.is_default == true ? 1 : 0,
            shipping_area: values?.area,
            shipping_country: values?.country_id,
            shipping_state: values?.state_id,
            shipping_city: values?.city,
            shipping_is_active: 1,
        };
        let editShippingValues = {
            ...shippingvalues,
            address_line_two: shippingvalues?.shipping_address_line_two,
        };
        try {
            let shipping = function modeAPIShippingCall() {
                if (shippingvalues?.id) {
                    return updateShippingAddressApi(editShippingValues, token);
                } else {
                    return createShippingAddressApi(shippingvalues, token);
                }
            };
            let apicall = shipping();
            const response = await apicall;
            //   const response = await createShippingAddressApi(
            //     shippingvalues,
            //     token
            //   );
            if (response.status_code == 200) {
                toast.success(
                    `Shipping address ${
                        shippingvalues?.id ? "Updated" : "Added"
                    }  successfully!`,
                );
                getShippingAddressData(token);
                setIsAddressForm(false);
                setActiveTab("description");
                billingAddressFormik.resetForm();
                shippingAddressFormik.resetForm();
                setIsDisabled(false);
            }
        } catch (error) {
            setIsDisabled(false);
        }
    }
    const handleBillingShippingSame = (e) => {
        shippingAddressFormik.setFieldValue("terms_agree", e.target.checked);
        if (e.target.checked) {
            shippingAddressFormik.setValues(billingAddressFormik.values);
        } else {
            shippingAddressFormik.resetForm();
        }
    };
    const [selectedBillingAddressId, setSelectedBillingAddressId] =
        useState(null);

    const [selectedShippingAddressId, setSelectedShippingAddressId] =
        useState(null);

    const handleBillingAddressSelect = (id) => {
        setSelectedBillingAddressId(id);
    };

    const handleShippingAddressSelect = (id) => {
        setSelectedShippingAddressId(id);
    };
    useEffect(() => {
        let defaultBillingAddressId = billingAddress?.find(
            (x) => x?.billing_set_default === 1,
        );
        let defaultShippingAddressId = shippingAddress?.find(
            (x) => x?.shipping_set_default === 1,
        );

        setSelectedBillingAddressId(
            defaultBillingAddressId?.billing_address_id,
        );
        setSelectedShippingAddressId(
            defaultShippingAddressId?.shipping_address_id,
        );
    }, [billingAddress, shippingAddress]);
    const placeOrderContinue = async () => {
        if (Object.keys(cartTotalAmount)?.length === 0) {
            toast.warn("Please add one item in cart !");
            return;
        }
        if (!selectedBillingAddressId || !selectedShippingAddressId) {
            toast.warn("Please select billing and shipping address !");
            return;
        }
        const payload = {
            billing_address_id: selectedBillingAddressId,
            shipping_address_id: selectedShippingAddressId,
        };
        setIsPlaceOrder(true);
        try {
            const response = await placeOrderCreate(payload, token);
            if (response.status_code === 200) {
                toast.success("Order placed successfully !");
                setIsPlaceOrder(false);
                const orderId = response.data;
                const data = { order_id: orderId };
                const encodedData = btoa(JSON.stringify(data));
                //  window.location.href =  `${import.meta.env.VITE_APP_URL}/manual-payment?F1!sO=${encodedData}`;
                window.location.href = `/pg/manual-payment?F1!sO=${encodedData}`;
                document.getElementById("placeOrderButton").disabled = false;
            }
        } catch (error) {
            setIsPlaceOrder(false);
            document.getElementById("placeOrderButton").disabled = false;
            console.error(error);
        }
    };
    return (
        <div className="container">
            <div className="row ">
                <div className="col-lg-8 p-0">
                    <div>
                        <Cart />

                        <div className="check-out-billing-shipping">
                            <h4 className="fw-bold px-2">
                                Billing and Shipping Address
                            </h4>
                            <div className="d-flex justify-content-end px-3">
                                <button
                                    className="addnew-address-btn   d-block"
                                    onClick={() => setIsAddressForm(true)}
                                >
                                    add new address
                                </button>
                            </div>

                            <div className="d-flex gap-4 mt-4 flex-wrap">
                                <div
                                    style={{
                                        height: "280px",
                                        overflowY: "auto",
                                        scrollbarWidth: "thin",
                                        width: "380px",
                                        padding: "5px",
                                        // width: "100%",
                                    }}
                                    //  className="d-flex flex-column"
                                >
                                    {billingAddress?.length > 0 &&
                                        billingAddress?.map((x, index) => {
                                            return (
                                                <div
                                                    className="mt-2"
                                                    key={index}
                                                >
                                                    <AddressDetails
                                                        id={
                                                            x?.billing_address_id
                                                        }
                                                        isDefault={
                                                            x?.billing_set_default ===
                                                            1
                                                                ? true
                                                                : false
                                                        }
                                                        name={
                                                            x?.billing_name ||
                                                            ""
                                                        }
                                                        area={x?.billing_area}
                                                        addressTag={"Billing"}
                                                        addressOne={
                                                            x?.billing_address_line_one
                                                        }
                                                        addressTwo={
                                                            x?.billing_address_line_two
                                                        }
                                                        country={
                                                            x?.billing_country
                                                        }
                                                        state={x?.billing_state}
                                                        city={x?.billing_city}
                                                        pincode={
                                                            x?.billing_pincode
                                                        }
                                                        mobileNo={
                                                            x?.billing_phone_no
                                                        }
                                                        selectedId={
                                                            selectedBillingAddressId
                                                        }
                                                        handleAddressSelect={
                                                            handleBillingAddressSelect
                                                        }
                                                    />
                                                </div>
                                            );
                                        })}
                                </div>
                                <div
                                    style={{
                                        height: "280px",
                                        overflowY: "auto",
                                        scrollbarWidth: "thin",
                                        width: "380px",
                                        padding: "5px",
                                        // width:"100%"
                                    }}
                                    // className="d-flex flex-column"
                                >
                                    {shippingAddress?.length > 0 &&
                                        shippingAddress?.map((x, index) => {
                                            return (
                                                <div
                                                    className="mt-2"
                                                    key={index}
                                                >
                                                    <AddressDetails
                                                        id={
                                                            x?.shipping_address_id
                                                        }
                                                        isDefault={
                                                            x?.shipping_set_default ===
                                                            1
                                                                ? true
                                                                : false
                                                        }
                                                        name={
                                                            x?.shipping_name ||
                                                            ""
                                                        }
                                                        area={x?.shipping_area}
                                                        addressTag={"Shipping"}
                                                        addressOne={
                                                            x?.shipping_address_line_one
                                                        }
                                                        addressTwo={
                                                            x?.shipping_address_line_two
                                                        }
                                                        country={
                                                            x?.shipping_country
                                                        }
                                                        state={
                                                            x?.shipping_state
                                                        }
                                                        city={x?.shipping_city}
                                                        pincode={
                                                            x?.shipping_pincode
                                                        }
                                                        mobileNo={
                                                            x?.shipping_phone_no
                                                        }
                                                        selectedId={
                                                            selectedShippingAddressId
                                                        }
                                                        handleAddressSelect={
                                                            handleShippingAddressSelect
                                                        }
                                                    />
                                                </div>
                                            );
                                        })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 p-0 my-5">
                    <div className="checkout-payment-container">
                        <h5 style={{ fontWeight: 700, fontSize: "1.2rem" }}>
                            Payment method
                        </h5>
                        <div className="check-out-payment-method">
                            <input type="radio" checked={true} readOnly />
                            <label htmlFor="">Online payment</label>
                        </div>

                        <form
                            action=""
                            onSubmit={formik.handleSubmit}
                            className="checkout-coupon-input-container"
                        >
                            <h5 style={{ fontWeight: 700, fontSize: "1.2rem" }}>
                                COUPON
                            </h5>
                            <input
                                type="text"
                                placeholder="Enter coupon code here..."
                                value={formik.values.coupon_code}
                                onChange={formik.handleChange}
                                name="coupon_code"
                                id="coupon_code"
                                className={` ${
                                    formik.errors.coupon_code &&
                                    formik.touched.coupon_code
                                        ? "is-invalid"
                                        : ""
                                }`}
                            />
                            {formik.errors.coupon_code &&
                                formik.touched.coupon_code && (
                                    <div className="invalid-feedback">
                                        {formik.errors.coupon_code}
                                    </div>
                                )}
                            <button className="coupon-btn" type="submit">
                                {coupenLoading ? "Loading.." : "Apply Coupon"}
                            </button>
                        </form>

                        <div className="cart-price-details my-4">
                            <h5 className="card-title ">Price Details</h5>
                            <ul>
                                <li>
                                    <span className="fw-bold">
                                        total original price
                                    </span>
                                    <span className="fw-bold">
                                        ₹
                                        {cartTotalAmount?.total_original_amount?.toFixed(
                                            2,
                                        ) || "0"}
                                    </span>
                                </li>
                                <li>
                                    <span className="fw-bold">total tax</span>
                                    <span className="fw-bold">
                                        ₹
                                        {cartTotalAmount?.total_tax_amount?.toFixed(
                                            2,
                                        ) || "0"}
                                    </span>
                                </li>
                                <li>
                                    <span className="fw-bold">
                                        total sales amount
                                    </span>
                                    <span className="fw-bold">
                                        ₹
                                        {cartTotalAmount?.total_sales_amount?.toFixed(
                                            2,
                                        ) || "0"}
                                    </span>
                                </li>
                                <li>
                                    <span className="fw-bold">
                                        shipping fee
                                    </span>
                                    <span className="fw-bold">free</span>
                                </li>
                                <li>
                                    <span className="fw-bold">
                                        total amount
                                    </span>
                                    <span className="fw-bold">
                                        ₹
                                        {cartTotalAmount?.total_price?.toFixed(
                                            2,
                                        ) || "0"}
                                    </span>
                                </li>
                            </ul>

                            <button
                                id="placeOrderButton"
                                className="place-order-btn"
                                onClick={placeOrderContinue}
                                disabled={isPlaceOrder}
                            >
                                {isPlaceOrder ? (
                                    <>
                                        {" "}
                                        <Spinner
                                            animation="grow"
                                            style={{
                                                width: "0.8rem",
                                                height: "0.8rem",
                                            }}
                                        />{" "}
                                        <Spinner
                                            animation="grow"
                                            style={{
                                                width: "0.8rem",
                                                height: "0.8rem",
                                            }}
                                        />{" "}
                                        <Spinner
                                            animation="grow"
                                            style={{
                                                width: "0.8rem",
                                                height: "0.8rem",
                                            }}
                                        />
                                    </>
                                ) : (
                                    "place order"
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {isAddressForm && (
                <AppModal
                    title="Add New Address"
                    size="lg"
                    show={isAddressForm}
                    onHide={() => {
                        setIsAddressForm(false);
                        billingAddressFormik.resetForm();
                        shippingAddressFormik.resetForm();
                        setActiveTab("description");
                    }}
                >
                    <div className="tab tab-nav-simple mt-1">
                        <ul
                            className="nav nav-tabs justify-content-center"
                            role="tablist"
                        >
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${
                                        activeTab === "description"
                                            ? "active"
                                            : ""
                                    }`}
                                    onClick={() =>
                                        handleTabClick("description")
                                    }
                                >
                                    Billing
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${
                                        activeTab === "specification"
                                            ? "active"
                                            : ""
                                    }`}
                                    onClick={() =>
                                        handleTabClick("specification")
                                    }
                                >
                                    Shipping
                                </button>
                            </li>
                        </ul>
                        <div className="tab-content">
                            {activeTab === "description" && (
                                <div
                                    className="tab-pane active in"
                                    id="product-tab-additional"
                                >
                                    <AddressForm
                                        activeTab={activeTab}
                                        formik={billingAddressFormik}
                                        pincodeValidationError={
                                            pincodeValidationError
                                        }
                                    />
                                </div>
                            )}
                            {activeTab === "specification" && (
                                <div
                                    className="tab-pane active in"
                                    id="product-tab-additional"
                                >
                                    <AddressForm
                                        activeTab={activeTab}
                                        formik={shippingAddressFormik}
                                        handleBillingShippingSame={
                                            handleBillingShippingSame
                                        }
                                        pincodeValidationError={
                                            pincodeValidationError
                                        }
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </AppModal>
            )}
        </div>
    );
}

export default CheckOut;
